import { Menu, Text } from '@mantine/core'
import { IconClock } from '@tabler/icons-react'

interface Props {
  currentTimezone: string | null
  disabled?: boolean
  onSelect: (timezone: string | null) => void
}

const TIMEZONE_OPTIONS: { value: string | null; label: string }[] = [
  { value: null, label: 'Padrão do sistema' },
  { value: 'America/Sao_Paulo', label: 'America/Sao_Paulo (BRT)' },
  { value: 'America/Manaus', label: 'America/Manaus (AMT)' },
  { value: 'America/Belem', label: 'America/Belem' },
  { value: 'America/Fortaleza', label: 'America/Fortaleza' },
  { value: 'America/Recife', label: 'America/Recife' },
  { value: 'UTC', label: 'UTC' },
]

export function TimezoneMenu({ currentTimezone, disabled, onSelect }: Props) {
  return (
    <>
      <Menu.Label>
        <IconClock size={12} style={{ verticalAlign: 'middle', marginRight: 4 }} />
        Fuso horário
        {currentTimezone && (
          <Text size="xs" c="dimmed" component="span" ml="xs">
            (atual: {currentTimezone})
          </Text>
        )}
      </Menu.Label>
      {TIMEZONE_OPTIONS.map((opt) => (
        <Menu.Item
          key={opt.value ?? 'null'}
          disabled={disabled}
          onClick={() => onSelect(opt.value)}
          data-testid={`tz-option-${opt.value ?? 'default'}`}
        >
          {opt.label}
          {currentTimezone === opt.value && (
            <Text size="xs" c="teal" component="span" ml="xs">
              ✓
            </Text>
          )}
        </Menu.Item>
      ))}
    </>
  )
}
